import Vue from 'vue'
import Router from 'vue-router'
import Callback from './components/oidc/callback.vue'
import callbackError from './components/oidc/callbackError.vue'
import resources from './components/Truck&Trailers/services.vue'
import customers from './views/Customers/Customers.vue'
import users from './components/users/users.vue'
import kanban from './views/MyTask/MyTask.vue'
import accessDenied from './components/alertas/AccessDenied.vue'
import hours from './components/Truck&Trailers/horas.vue'
import reporthours from './components/Truck&Trailers/reporthoras.vue'
import home from './views/Home.vue'
import request from './components/request/index.vue'

//@ts-ignore
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base:`${process.env.VUE_APP_ROUTER_ROOT_PATH}`,
  routes: [
    {
      path: '/request',
      name: 'request',
      component: request,
      meta:{
        isPublic: false
      },
      beforeEnter:(to, from, next) => {
        if(verifyRoles('Administrator')){
          next()
        }else{
          next('/accessDenied')
        }
      }
    },
    /*
    {
      path: '/',
      name: 'home',
      component: home,
      meta:{
        isPublic: true
      }
    },
    */
    {
      path:'/accessDenied',
      name:'accessDenied',
      component: accessDenied,
      meta:{
        isPublic: true
      }
    },
    {
      path: '/oidc-callback', // Needs to match redirect_uri in you oidcSettings
      name: 'oidcCallback',
      component: Callback,
      meta: {
          isOidcCallback: true,
          isPublic: true
      }
    },
    {
      path: '/oidc-callback-error', // Needs to match redirect_uri in you oidcSettings
      name: 'oidcCallbackError',
      component: callbackError,
      meta: {
          isPublic: true
      }
    },
    {
      path: '/kanban/task/:ticket/travelWorker/:idTravelWorker',
      name: 'InspeccionContrato',
      component: () => import('./components/Task/inspection.vue'),
      props: true
    },
    {
      path:'/hours',
      name: 'hours',
      component:hours,
      meta:{ isPublic: false},
      beforeEnter:(to, from, next) => {
        if(verifyRoles('Administrator')){
          next()
        }else{
          next('/accessDenied')
        }
      },
    },
    {
      path:'/reporthours',
      name: 'reporthours',
      component:reporthours,
      meta:{ isPublic: false},
      beforeEnter:(to, from, next) => {
        if(verifyRoles('Worker')){
          next()
        }else{
          next('/accessDenied')
        }
      },
    },
    {
      path: "/kanban",
      name: "kanban",
      component: kanban,
      beforeEnter:(to, from, next) => {
        if(verifyRoles(['Administrator', 'Worker'])){
          next()
        }else{
          next('/accessDenied')
        }
      },
      meta:{
        isPublic: true
      }
    },
    {
      path: "/customers",
      name: "customers",
      component: customers,
      beforeEnter:(to, from, next) => {
        if(verifyRoles('Administrator')){
          next()
        }else{
          next('/accessDenied')
        }
      },
      meta:{
        isPublic: false
      }
    },
    {
      path: "/services",
      name: "resources",
      component: resources,
      beforeEnter:(to, from, next) => {
        if(verifyRoles(['Administrator','Worker'])){
          next()
        }else{
          next('/accessDenied')
        }
      },
      meta:{
        isPublic: false
      }
    },
    {
      path: "/users",
      name: "users",
      component: users,
      beforeEnter:(to, from, next) => {
        if(verifyRoles('Administrator')){
          next()
        }else{
          next('/accessDenied')
        }
      },
      meta:{
        isPublic: false
      }
    },
  ]
})

function verifyRoles(rol: any) : Boolean {
  var value = false
  let userRoles = store.getters['oidcStore/oidcUser'].role
  //console.log('ver si es arrary ==> ', userRoles instanceof Array)
  if(rol === userRoles){
    value=true
  }else{
    if(rol instanceof Array){
      rol.forEach(element => {
        if(element === userRoles){
          value = true
          return
        }
      });
    }
  }
  //console.log('roles => ', userRoles)
  /*
  if(userRoles instanceof Array && rol instanceof Array){
    userRoles.forEach(element => {
      if(rol.indexOf(element)> -1)
        value = true
        return 
    });
  }else{
    if(userRoles instanceof Array === false && rol instanceof Array){
      console.log('userroles es arrary pero rol no')
      rol.forEach(element => {
        if(element === userRoles)
          value = true
          return
      });
    }else if(userRoles instanceof Array  && rol instanceof Array === false){
        console.log('userroles es arrary pero rol no')
        userRoles.forEach(element => {
        if(element === rol)
          value = true
          return
      }); 
    }else{
        console.log('entro al else', rol instanceof Array, userRoles , rol)
        if(userRoles == rol) 
        value = true
        return
    }
  }*/
  return value
}

router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'))

export default router
